import notification_utility from "./notification_utility";

export default {
  name: "notification_dialog",
  components: {
  },
  props: ['showDialog', 'grp_details'],
  data: () => ({
    snackbar: false,
    err_msg: '',
    notification: 0,
    sound: 0,
    grp: {},
    loading: false
  }),
  computed: {
    dialog: {
      get: function () {
        return this.showDialog;
      },
      set: function (value) {
        this.$emit("dialogClose", value);
      }
    },
    userData() {
      return this.$store.getters.userData;
    },
    async selectedGroup() {
      return await this.$store.getters.selectedGroup;
    },
    async getChatgrpList() {
      return await this.$store.getters.getChatgrpList;
    },
  },
  mounted() {
    this.group_setting_get(this.grp);
  },
  methods: {
    /**
    * dialog_close
    */
    dialog_close() {
      this.dialog = false;
      this.snackbar = false;
      this.err_msg = '';
      window.setTimeout(() => {
        this.group_setting_get(this.grp);
      }, 100);
    },
    /**
      * group_notification_save
      */
    group_notification_save: function () {
      this.notification = (this.notification) ? 1 : 0;
      this.sound = (this.sound) ? 1 : 0;
      notification_utility.group_notification_save(this, this.grp.group_id, this.notification, this.sound);
    },
    /**
    * update_group_notification_setting_chatgrp_list
    */
    update_group_notification_setting_chatgrp_list: async function (settings) {
      notification_utility.update_group_notification_setting_chatgrp_list(this, settings);
    },
    /**
    * group_setting_get
    */
   group_setting_get: function (grp) {
      let settings = (grp.settings) ? JSON.parse(grp.settings) : null;
      if (settings && settings != null) {
        let notification_setting = settings.notification;
        this.notification = (notification_setting.notification == "1") ? true : false;
        this.sound = (notification_setting.sound == "1") ? true : false;
      }
      else {
        this.notification = true;
        this.sound = false;
      }
    }
  },/*method closure */
  watch: {
    /**
     * grp_details
     */
    grp_details: function (grp) {
      this.group_setting_get(grp);
      this.grp = grp;
    },
  }
}
